<ng-container *ngIf="postingList.length">
    <h3 class="mb-8 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED' | translate }}</h3>
    <mat-chip-set class="chip-list wrap mb-16">
        <mat-chip class="chip maxbrain-500" (removed)="removeFromList(posting)" *ngFor="let posting of postingList">
            {{ posting.translations[0].title }}
            <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
    </mat-chip-set>
</ng-container>

<div fxLayout="row" fxLayoutAlign="space-between center" class="mb-24">
    <div fxLayout="row">
        <app-search-outline class="mr-8" [searchInput]="searchInput"></app-search-outline>

        <!-- POSTING TYPE FILTER -->
        <mat-form-field appearance="outline" class="w-200 mr-8 hide-subscript-wrapper" *ngIf="!isArticleContentType && !pickOnly">
            <mat-label>{{ 'GENERAL.LABEL.FILTER_BY_TYPE' | translate }}</mat-label>
            <mat-select #postingTypeSelect [formControl]="postingTypeInput">
                <mat-option [value]="null">
                    {{ 'GENERAL.PROPERTY.CLEAR_SELECTION' | translate }}
                </mat-option>
                <mat-option *ngFor="let postingType of postingTypes" [value]="postingType.id">
                    {{ postingType.name | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- LANGUAGE FILTER -->
        <mat-form-field appearance="outline" class="responsive-filter-field hide-subscript-wrapper" *ngIf="!pickOnly">
            <mat-label>{{ 'GENERAL.PROPERTY.LANGUAGE' | translate }}</mat-label>
            <mat-select [formControl]="languageInput">
                <mat-option [value]="null">
                    {{ 'GENERAL.PROPERTY.CLEAR_SELECTION' | translate }}
                </mat-option>
                <mat-option *ngFor="let lang of languageService.languages | filterLanguages" [value]="lang.id">
                    <span fxLayout="row" fxLayoutAlign="start center">
                        <img alt="" class="flag mr-16" [src]="'assets/images/flags/' + lang.flag + '.svg'" />
                        <span class="iso" [translate]="lang.translate">{{ lang.title }}</span>
                    </span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <app-white-button
        [icon]="'add'"
        [label]="'ENGAGE.POSTING.HEADER'"
        (onClick)="openDialogEngageNewPosting()"
        *ngIf="selectedContentTypeId !== ContentTypeEnum.Article"
    ></app-white-button>
</div>

<app-select-postings-list
    [postings$]="postings$"
    [postingsStateSearchTerm$]="postingsStateSearchTerm$"
    [postingsStateTotalCount$]="postingsStateTotalCount$"
    [loadPostings$]="loadPostings$"
    [selectedPostingTypeId]="selectedPostingTypeId"
    [selectedLanguageId]="selectedLanguageId"
    [singleSelect]="pickOnly"
    (updateList)="updateList($event)"
    [removePostingFromList$]="removePostingFromList$"
    [selectedContentTypeId]="selectedContentTypeId"
    [onlyValid]="onlyValid"
></app-select-postings-list>

<div mat-dialog-actions class="p-0 pt-24 w-full" fxLayout="row" fxLayoutAlign="space-between center">
    <app-white-button class="mr-8" [label]="'GENERAL.LABEL.CLEAR_SELECTION'" (onClick)="onClearSelection()"></app-white-button>
    <div fxLayout="row" fxLayoutAlign="end center">
        <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="closeDialog.emit(false)"></app-white-button>
        <app-flat-button
            [label]="pickOnly ? 'GENERAL.BUTTON.NEXT' : 'GENERAL.BUTTON.ADD'"
            (onClick)="save()"
            [isLoading]="isLoading"
            [disabled]="!postingList.length"
        ></app-flat-button>
    </div>
</div>
